module.exports = __webpack_public_path__ + "static/media/sthetoscope.abc6fa9e.jpg";